/**
 * User settings API – notification, org info, account deletion, payment.
 * Base path: /org (see lms-backend-v2 organizationroutes.js + user/settings/settings.route.js).
 */
import { GET, POST, PUT } from "../apiController";

const ORG = "/org";

// Notification settings
export const getNotificationSettings = () => {
  return GET(`${ORG}/get_notification_settings`);
};

export const updateNotificationSettings = (data) => {
  return PUT(`${ORG}/update_notification_settings`, data);
};

// About Us (org info)
export const getAboutUs = () => {
  return GET(`${ORG}/get_orginfo`);
};

// Account deletion (OTP + soft delete)
export const sendAccountDeletionOtp = () => POST(`${ORG}/account-deletion/send-otp`, {});

export const verifyAccountDeletionOtp = (data) => POST(`${ORG}/account-deletion/verify-otp`, data);

export const deleteAccount = (data) => POST(`${ORG}/account-deletion/delete`, data);

// Payment history
export const getPaymentHistory = () => {
  return GET(`${ORG}/get_user_transactions`);
};

// PayU (success/cancel; processPayUPayment moved to course.js)

export const successPayUPayment = (course_id, txnid) => {
  return GET(`${ORG}/success_payu_payment?course_id=${course_id}&txnid=${txnid}`);
};

export const cancelPayUPayment = (course_id, txnid) => {
  return GET(`${ORG}/cancel_payu_payment?course_id=${course_id}&txnid=${txnid}`);
};
